import styled from "styled-components";
import { Checkbox, Radio, Button } from "antd";

export const QuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  padding-left: 80px;
  width: 80%;
`;

export const QuestionText = styled.div`
  font-size: 2em;
  font-weight: bold;
  line-height: 3em;
`;

export const SubQuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  width: 60%;
`;

export const SubQuestionText = styled.div`
  font-size: 1.5em;
  font-weight: bold;
  line-height: 2em;
`;

export const CheckboxField = styled(Checkbox)`
  width: 40%;
  font-size: 16px;
  font-weight: 500;
  line-height: 2.5em;
  margin-left: 0 !important;

  .ant-checkbox-inner {
    border-color: black;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: black;
  }
`;

export const RadioField = styled(Radio)`
  font-size: 16px;
  font-weight: 500;
  line-height: 2em;

  .ant-radio-inner {
    border-color: black !important;
  }

  .ant-radio-checked .ant-radio-inner{
    border-color: black !important;
  }
  
  .ant-radio-checked .ant-radio-inner:after{
    background-color: black;
  }
  
  .ant-radio:hover .ant-radio-inner {
    border-color: black;
  }
`;

export const ButtonContainer = styled.div`
  margin-top: 30px;
`;

export const PrevButton = styled(Button)`
  background-color: white;
  color: #c52028;
  font-size: 17px;
  width: 130px;
  height: 50px;
  border-radius: 7px;
  margin-right: 30px;
  border-color: #c52028;

  &:hover {
    background-color: #c52028;
    color: white;
    border: none;
  }
  &:active {
    background-color: white;
    color: #c52028;
    border-color: #c52028;
  }
  &:focus {
    background-color: white;
    color: #c52028;
    border-color: #c52028;
  }
`;

export const NextButton = styled(Button)`
  background-color: #c52028;
  color: white;
  font-size: 17px;
  width: 130px;
  height: 50px;
  border-radius: 7px;
  margin-right: 30px;

  &:hover {
    background-color: #c52028;
    color: white;
    border: none;
  }
  &:active {
    background-color: #c52028;
    color: white;
    border-color: #d9d9d9;
  }
  &:focus {
    background-color: #c52028;
    color: white;
    border-color: #d9d9d9;
  }
`;